import { BULK_UPLOAD_TYPE_ID, BULK_UPLOAD_TYPE_NAME } from '../TypeOfCharge.types';
import HistoryAction from '../components/HistoryAction/HistoryAction';

interface IHistoryActions {
  actions: ((value: number) => void)[];
  values: (number | undefined)[];
}

export const historyActions = ({ actions, values }: IHistoryActions): JSX.Element[] => [
  <HistoryAction
    key={`${BULK_UPLOAD_TYPE_ID.ORDERS}-${BULK_UPLOAD_TYPE_NAME[BULK_UPLOAD_TYPE_ID.ORDERS]}`}
    action={actions[0]}
    label={BULK_UPLOAD_TYPE_NAME[BULK_UPLOAD_TYPE_ID.ORDERS]}
    value={BULK_UPLOAD_TYPE_ID.ORDERS}
    isActive={values[0] === BULK_UPLOAD_TYPE_ID.ORDERS}
  />,
  <HistoryAction
    key={`${BULK_UPLOAD_TYPE_ID.CATALOG}-${BULK_UPLOAD_TYPE_NAME[BULK_UPLOAD_TYPE_ID.CATALOG]}`}
    action={actions[0]}
    label={BULK_UPLOAD_TYPE_NAME[BULK_UPLOAD_TYPE_ID.CATALOG]}
    value={BULK_UPLOAD_TYPE_ID.CATALOG}
    isActive={values[0] === BULK_UPLOAD_TYPE_ID.CATALOG}
  />
];
